module.exports = __webpack_public_path__ + "static/img/mini-bus-grey.44b193b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/mini-bus-grey.svg
// module id = oGwM
// module chunks = 74